module.exports = __webpack_public_path__ + "static/service-2-14dd3d3e4925f6783e025af311bae6e2.mp4";